import PropTypes from 'prop-types';
import React from 'react';
const getFormattedVersion = version => {
  let formattedVersion = version;
  const parts = version.split('.');
  if (parts.length === 1) {
    formattedVersion = parts[0];
  } else if (parts.length === 3 && parts[2] === '0') {
    formattedVersion = "".concat(parts[0], ".").concat(parts[1]);
  }
  return formattedVersion;
};
const Version = _ref => {
  let name = _ref.name,
    _ref$build = _ref.build,
    propsBuild = _ref$build === void 0 ? '' : _ref$build,
    _ref$tag = _ref.tag,
    tag = _ref$tag === void 0 ? '' : _ref$tag,
    _ref$append = _ref.append,
    append = _ref$append === void 0 ? false : _ref$append,
    _ref$version = _ref.version,
    propsVersion = _ref$version === void 0 ? '' : _ref$version,
    _ref$env = _ref.env,
    env = _ref$env === void 0 ? '' : _ref$env;
  const version = getFormattedVersion(propsVersion);
  const message = "".concat(name, " ").concat(version);
  const build = [];
  let buildVersion;
  if (propsBuild) {
    build.push("#".concat(propsBuild));
  }
  if (tag) {
    build.push(tag);
  }
  if (build.length > 0) {
    buildVersion = "".concat(build.join(', '));
  }
  const output = version ? /*#__PURE__*/React.createElement("span", {
    title: buildVersion
  }, append ? ',' : '', " ", message, buildVersion && !['production', 'pre-prod', 'beta'].includes(env) && " (".concat(build[0], ")")) : '';
  return /*#__PURE__*/React.createElement("span", null, output);
};
Version.propTypes = {
  append: PropTypes.bool,
  build: PropTypes.string,
  name: PropTypes.string.isRequired,
  tag: PropTypes.string,
  version: PropTypes.string,
  env: PropTypes.string
};
export default Version;